import styles from "./draft-options.module.css";
import { usePosterProject } from "PosterEditor/model/poster-project-provider";
import { Toolbox } from "PosterEditor/sidebar/toolboxes/toolbox";
import { CTAButton } from "BEDROCK/shared-components/cta-button";
import { useState } from "react";
import {
  BackButton,
  DeleteButton,
} from "PosterEditor/common-components/ui-icon-drawing/ui-icon-button";
import {
  ToolboxComponentSection as Section,
  ToolboxSectionDivider as Divider,
} from "../../toolbox-components/toolbox-component-section";

interface DraftOptionsProps {}

export const DraftOptions = (props: DraftOptionsProps) => {
  const { project, saveDraft } = usePosterProject();

  return (
    <div className={styles.container}>
      <Toolbox collapsible={false} showTitleBar={false}>
        <div className={styles.paddedBodyContent}>
          {" "}
          <CTAButton
            onClick={() => {
              saveDraft();
            }}
          >
            Start customising
          </CTAButton>
        </div>
      </Toolbox>
    </div>
  );
};
